import { CONSULTATION_STEPS } from '@abiglobalhealth/go-types'

import { cancelConsultation } from '@/api/consultations'
import { BackButton } from '@/components/BackButton'
import { GeneralErrorsBanner } from '@/components/GeneralErrorsBanner'
import { AbiLogo } from '@/components/icons/AbiLogo'
import { Close } from '@/components/icons/Close'
import { useLoading } from '@/hooks/useLoading'
import { useModule } from '@/hooks/useModule'
import { useReminder } from '@/hooks/useReminder'
import { useStep } from '@/hooks/useStep'
import { useTheme } from '@/hooks/useTheme'
import { useUser } from '@/hooks/useUser'

const CANCELLABLE_STEPS = [CONSULTATION_STEPS.MATCH, CONSULTATION_STEPS.MATCHING, CONSULTATION_STEPS.WAITING_FOR_CONSULTATION_PAYMENT]

export const Header = () => {
  const { reminderSet } = useReminder()
  const { showLoading, hideLoading, loading } = useLoading()
  const { currentModule } = useModule()
  const { currentStep } = useStep()
  const { theme } = useTheme()
  const { user } = useUser()

  const handleCancelConsultation = () => {
    showLoading()

    cancelConsultation({
      uniqueId: user?.data?.uniqueId as string
    })
      .then(() => {
        window.location.reload()
      })
      .finally(() => {
        hideLoading()
      })
  }

  return (
    <div className={`sticky top-0 z-20 flex w-full flex-col ${reminderSet ? '' : 'shadow-xs'}`}>
      <header className="bg-header bg-header-pattern flex flex-col gap-2 bg-cover bg-no-repeat px-6 py-3">
        <div className="grid grid-cols-3 gap-x-2">
          {new RegExp(`consultation-(${CANCELLABLE_STEPS.join('|')})`).test(currentStep?.id as string) ? (
            <button onClick={handleCancelConsultation} className="disabled:opacity-50" disabled={loading}>
              <Close customClassName="text-header-text" />
            </button>
          ) : (
            <div className="flex items-center">{currentModule && currentStep?.backButton && <BackButton />}</div>
          )}

          {theme?.logo ? <img src={theme?.logo} alt="Logo" className="mx-auto h-12" /> : <AbiLogo className="text-header-text mx-auto h-12" />}
        </div>
      </header>

      <GeneralErrorsBanner />
    </div>
  )
}
